import React from 'react'
import { ActionButtonWrapper } from './OperationButtonStyles'
import { ActionButtonProps } from './interface'

export default function ActionButton({
  text,
  width,
  height,
  bg,
  fontSize,
  margin,
  func,
}: ActionButtonProps) {
  return (
    <ActionButtonWrapper
      width={width}
      height={height}
      bg={bg}
      fontSize={fontSize}
      onClick={() => func()}
      margin={margin}
    >
      <div className='btn'>
        <span>{text}</span>
      </div>
    </ActionButtonWrapper>
  )
}
